import React, { FC } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import PruRoute from 'src/app/common/components/PruRoute';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import { NOTE_PATH, SIMULATION_TOOL_PATH } from '../../constants';
import NoteSettingListingPage, { noteFilterKeys } from './List/NoteSettingListingPage';
import NoteSettingDetailPage from './Create/NoteSettingDetailPage';

const NoteManagementPage: FC<RouteComponentProps> = ({ history }) => {
  return (
    <Switch>
      <Redirect
        exact
        from={`${SIMULATION_TOOL_PATH}${NOTE_PATH}`}
        to={`${SIMULATION_TOOL_PATH}${NOTE_PATH}/list`}
      />
      <PruRoute
        exact
        path={`${SIMULATION_TOOL_PATH}${NOTE_PATH}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={noteFilterKeys}>
            <NoteSettingListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute exact path={`${SIMULATION_TOOL_PATH}${NOTE_PATH}/edit/:id`} component={NoteSettingDetailPage} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default NoteManagementPage;